import { LEGACY_SCREEN_VIEW, PRICE_SCHEDULE_MODES } from "./Constants";

export const isAddMode = (mode) => mode === PRICE_SCHEDULE_MODES.ADD;
export const isReadOnlyMode = (mode) => mode === PRICE_SCHEDULE_MODES.READ_ONLY;
export const isEditMode = (mode) => mode === PRICE_SCHEDULE_MODES.EDIT;

export const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const day = currentDate.getDate().toString().padStart(2, "0");
  return year + month + day;
};
export const formatDate = (input) => {
  let formattedDate = "";
  if (input) {
    const inputStr = input.toString();
    let month = "";
    let day = "";
    let year = "";
    if (inputStr.length === 5) {
      month = month + "0" + inputStr.slice(0, 1);
      day = inputStr.slice(1, 3);
      year = inputStr.slice(3, 5);
    } else {
      month = inputStr.slice(0, 2);
      day = inputStr.slice(2, 4);
      year = inputStr.slice(4, 6);
    }
    formattedDate = formattedDate + `${month}/${day}/${year}`;
  }
  return formattedDate;
};
export const convertDateString = (dateString) => {
  // Ensure the input is a string and has the correct length
  if (typeof dateString !== "string" || dateString.length !== 8) {
    console.error("Invalid date format", dateString);
    return null;
  }

  // Extract year, month, and day from the input string
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  // Construct the new date string in mm/dd/yyyy format
  const formattedDate = `${month}/${day}/${year}`;

  return formattedDate;
};

export const processFieldNature = (fieldNatureString) => {
  // Split the input string into an array

  // Initialize readOnly and hidden arrays
  const readOnly = [];
  const hidden = [];
  if (!fieldNatureString) return { readOnly, hidden };

  const fieldNatureArray = fieldNatureString.split(",");

  // Iterate through each item in the array
  fieldNatureArray.forEach((item) => {
    let [mode, fieldNature] = item.split(":");
    mode = mode?.trim();
    fieldNature = fieldNature?.trim()?.toUpperCase();
    // Determine the mode and field nature
    if (mode === PRICE_SCHEDULE_MODES.ADD) {
      if (fieldNature === "READ-ONLY") {
        readOnly.push(PRICE_SCHEDULE_MODES.ADD);
      } else if (fieldNature === "NON-DISPLAY") {
        hidden.push(PRICE_SCHEDULE_MODES.ADD);
      }
    } else if (mode === PRICE_SCHEDULE_MODES.EDIT) {
      if (fieldNature === "READ-ONLY") {
        readOnly.push(PRICE_SCHEDULE_MODES.EDIT);
      } else if (fieldNature === "NON-DISPLAY") {
        hidden.push(PRICE_SCHEDULE_MODES.EDIT);
      }
    } else if (mode === PRICE_SCHEDULE_MODES.READ_ONLY) {
      if (fieldNature === "READ-ONLY") {
        readOnly.push(PRICE_SCHEDULE_MODES.READ_ONLY);
      } else if (fieldNature === "NON-DISPLAY") {
        hidden.push(PRICE_SCHEDULE_MODES.READ_ONLY);
      }
    }
  });

  return { readOnly, hidden };
};
export const LegacyResolvers = {
  formatDateForPresto: (date) => {
    // Check if date is provided and is a string
    if (!date || typeof date !== "string") {
      return "Invalid date format";
    }

    // Use regular expression to validate and capture mm, dd, yyyy
    const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = date.match(datePattern);

    // If the input does not match mm/dd/yyyy format, return error
    if (!match) {
      return "Invalid date format";
    }

    const [, month, day, year] = match;

    // Check if the month, day, and year are valid numbers
    if (month > 12 || month < 1 || day > 31 || day < 1) {
      return "Invalid date";
    }

    // Return formatted date in yyyy-mm-dd format
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  },
};

export const downloadCSV = (response) => {
  const contentDisposition = response.headers["content-disposition"];
  //console.log("content disposition", contentDisposition);
  const fileName = contentDisposition.split("filename=")[1] ?? "data.csv";
  const blob = new Blob([response?.data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatNumber = (value, fractionDigits) => {
  const numericValue = parseFloat(value);
  if (!isNaN(numericValue)) {
    return fractionDigits ? numericValue.toFixed(fractionDigits) : numericValue;
  }
  return value;
};

/**
 * Creates new `PreviousState` array after updating `paramsData`
 * @param {any[]} previousState
 * @param {Object=} paramUpdates
 * @returns {any[]} updatedPreviousState
 */
export function getUpdatedPreviousState(previousState, paramUpdates) {
  const [previousLastRecord = {}] = previousState.splice(
    previousState.length - 1,
    1
  );
  const { paramsData = {} } = previousLastRecord;
  const updatedParamsData = {
    ...paramsData,
    ...paramUpdates,
  };
  const updatedPreviousState = [
    ...previousState,
    { ...previousLastRecord, paramsData: updatedParamsData },
  ];
  return updatedPreviousState;
}

/**
 * Send a post message to parent window
 * @param {string} programCode to map with legacy
 * @param {Record<string, any>} parameters
 */
export function navigateToPresto(programCode, parameters) {
  const legacyScreenNumber = LEGACY_SCREEN_VIEW[programCode];

  if (!legacyScreenNumber) {
    console.error(
      "programCode ",
      programCode,
      " not found in LEGACY_SCREEN_VIEW",
      LEGACY_SCREEN_VIEW
    );
    return;
  }

  const message = {
    message: "navigate-to-presto",
    programCode: legacyScreenNumber,
    parameters,
  };
  window.top?.postMessage(message, "*");
  console.info(
    "%c postMessage ",
    "background: blue; color: white",
    "sent with the data",
    message
  );
}

/**
 * Navigate to previous page on back button click with the additional params passed
 * @param {Function} navigateToPage helper function for route navigation
 * @param {string} previousScreen
 * @param {Array<any>} previousState
 * @param {{}} params
 */
export const navigateToPreviousPageWithParams = (
  navigateToPage,
  previousScreen,
  previousState,
  params
) => {
  const lastPrevStateIndex = previousState?.length - 1;
  const state = [
    ...previousState.slice(0, lastPrevStateIndex),
    {
      ...previousState[lastPrevStateIndex],
      ...params,
    },
  ];
  navigateToPage(previousScreen, state);
};

export const fetchDataCallOnInitialLoad = (fetchData, lookupType) => {
  const windowSelfName = window?.self?.name || null;
  if (
    !windowSelfName ||
    (windowSelfName === "external-lookup-iframe" &&
      lookupType === "external") ||
    windowSelfName !== "external-lookup-iframe"
  ) {
    fetchData();
  }
};

export const scrollToElement = (element) => {
  if (!element) return null;
  if (element) {
    window.scrollTo({
      top: element?.getBoundingClientRect()?.top + window.scrollY,
      behavior: "smooth",
    });
  }
};

export const isElementVisibleInViewport = (el) => {
  if (!el) return null;
  const elementRect = el?.getBoundingClientRect();
  return (
    elementRect.bottom >= 0 &&
    elementRect.bottom + elementRect.height < window.innerHeight
  );
};

export const getHostnameWithPath = (url) => {
  const urlObj = new URL(url);
  const cleanUrl = `${urlObj.protocol}//${urlObj.host}${urlObj.pathname}`;
  return cleanUrl;
};

export const onShowCalendarOverlay = (
  selectedDate = null,
  calendarRef = null
) => {
  if (!calendarRef) return;
  const isDateProvided = selectedDate instanceof Date;
  const timer = setTimeout(() => {
    const highlightedDate =
      calendarRef
        .getOverlay?.()
        ?.querySelector(
          isDateProvided ? "span.p-highlight" : "td.p-datepicker-today span"
        ) || null;
    highlightedDate?.focus?.();
    clearTimeout(timer);
  }, 100);
};

export const dispatchBackBtnTriggeredEvent = () => {
  window.dispatchEvent(
    new CustomEvent("BackButtonTriggered", { detail: { isBackClicked: true } })
  );
};

export const isBackBtnKey = (keyName, key) => keyName?.[key] === "Back";
